import UnsplashPicker from '../UnsplashPicker.jsx';
import { useState } from 'react';
import SelectButtonIcon from '../icons/SelectButtonIcon.jsx';
import IconSelectButton from '../IconSelectButton.jsx';
import TextInput from '../TextInput';
import StackedPanel from '../StackedPanel.jsx';
import StylesHeaderCover from './StylesHeaderCover.jsx';
import StylesHeaderLogo from './StylesHeaderLogo.jsx';

const StylesHeader = ({ objectId, objectType, styles, setStyles }) => {
    return (
        <div>
            <StylesHeaderCover styles={styles} setStyles={setStyles} />
            <StylesHeaderLogo
                styles={styles}
                setStyles={setStyles}
                objectId={objectId}
                objectType={objectType}
            />
            <div className="mt-4">
                <div className="panel-label">Header Height</div>
                <div className="p-6 bg-gray-200 rounded-lg">
                    <TextInput
                        type="range"
                        value={styles?.headerHeight}
                        onChange={newValue =>
                            setStyles({ ...styles, headerHeight: newValue })
                        }
                        min={16}
                        max={144}
                        step={32}
                    />
                </div>
            </div>
        </div>
    );
};

export default StylesHeader;
